export { StockPage as default } from '@/components/pages/Ir/Stock'
